import {
  MutableRefObject,
  RefObject,
  createContext,
  useContext as useContextOrigin,
} from 'react';
import { useSelector } from 'app/store/utils/redux/hooks';

import Controller from '../lib/Controller';

interface IUseFlipbook {
  totalPages: number,
  visiblePages: Array<number>,
  pageId: number,
  isVisible: boolean,
  isOpened: boolean,
}

interface IFlipbookContext {
  pageId: number;
  controller?: Controller | null;
  isVisible: boolean;
  isOpened: boolean;
}

interface IFlipbookContextDefault {
  pageId: number;
  controllerRef?: MutableRefObject<Controller | undefined>;
  isVisible: boolean;
  isOpened: boolean;
}

export const FlipbookContext = createContext({
  pageId: -1,
  controllerRef: undefined,
  isVisible: false,
  isOpened: false,
} as IFlipbookContextDefault);

export const useFlipbookContext = (): IFlipbookContext => {
  const {
    pageId,
    controllerRef,
    isVisible,
    isOpened,
  } = useContextOrigin(FlipbookContext);

  const controller: Controller | undefined = controllerRef?.current;
  return {
    pageId,
    controller,
    isVisible,
    isOpened,
  };
};

export const useFlipbook = (ref: MutableRefObject<HTMLDivElement | undefined> | RefObject<HTMLDivElement | undefined>): IUseFlipbook => {
  const totalPages = useSelector((state) => state.flipbook.count);
  const visiblePages = useSelector((state) => state.flipbook.visiblePages);
  const currentPage = useSelector((state) => state.flipbook.currentPage);
  const page = ref.current ? (ref.current.closest('[data-name="flipbook-page"]') as HTMLElement) : null;
  const pageId = page ? Number(page.getAttribute('data-id')) : -1;
  const isVisible = visiblePages.includes(pageId);
  const isOpened = pageId === currentPage;
  return {
    totalPages,
    visiblePages,
    pageId,
    isVisible,
    isOpened,
  };
};
